<template>
  <div :class="$style.spotlightAttributes">
    <component
      :is="spotlightComponent"
      v-for="(spotlightComponent, index) in spotlightAttributes"
      :key="`spotlight-component-${index}`"
      :listing="listing"
      :listerBranding="listerBranding"
      @savePriceDropAlert="handleSavePriceDropAlert(spotlightComponent, $event)"
    />
  </div>
</template>

<script lang="ts" setup>
import { Listing } from '@smg-real-estate/hg-rets-schema';
import { computed } from 'vue';

import SpotlightAttributesNumberOfRooms from '@/components/SpotlightAttributes/SpotlightAttributesNumberOfRooms.vue';
import SpotlightAttributesPrice from '@/components/SpotlightAttributes/SpotlightAttributesPrice.vue';
import SpotlightAttributesUsableSpace from '@/components/SpotlightAttributes/SpotlightAttributesUsableSpace.vue';
import { isPlatformIs24 } from '@/helpers/platformDetection';
import { CreatePriceDropAlertEmitPayload } from '@/store/types/price-drop-alert-state';

type SpotlightComponent =
  | typeof SpotlightAttributesPrice
  | typeof SpotlightAttributesNumberOfRooms
  | typeof SpotlightAttributesUsableSpace;

defineOptions({
  name: 'SpotlightAttributes',
});

interface Props {
  listing: Listing;
  listerBranding: ListerBranding | null;
}
defineProps<Props>();

const emit = defineEmits<{
  savePriceDropAlert: [event: CreatePriceDropAlertEmitPayload];
}>();

const spotlightAttributes = computed(() => {
  if (isPlatformIs24()) {
    return [
      SpotlightAttributesNumberOfRooms,
      SpotlightAttributesUsableSpace,
      SpotlightAttributesPrice,
    ];
  } else {
    return [
      SpotlightAttributesPrice,
      SpotlightAttributesNumberOfRooms,
      SpotlightAttributesUsableSpace,
    ];
  }
});

const handleSavePriceDropAlert = (
  component: SpotlightComponent,
  event: CreatePriceDropAlertEmitPayload,
): void => {
  if (component === SpotlightAttributesPrice) {
    emit('savePriceDropAlert', event);
  }
};
</script>

<style module lang="scss">
@import './SpotlightAttributes';
</style>
